// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"13":"0c428ae2","296":"ea88be26","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"13":"85faad78c5f3a032027b","296":"3086e36bdbff2cb631b8","532":"c5e28fd366e65b876eca","678":"7d09aa6b3f452a88b009","883":"6eeb7c1a86310855087c"}[chunkId] + ".js";
};